/**
 * Custom `PageCount` component declaration.
 * Page number to PDF
 * @param {Number} current 
 * @param {Number} total
 * @return PageCount
*/
const PageCount = ({ current, total }: any) => (
  <span className="preview-pagecount">
    {current + 1} / {total}
  </span>
);

export default PageCount;